import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";
import { deleteSkill, getSkills } from "../../../../services/SkillService";

const SkillList = () => {
  const [skills, setSkills] = useState([]);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    try {
      const data = await getSkills();
      setSkills(data);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteSkill(id);
      fetchSkills(); // Refresh list after deletion
      console.log("Skill deleted successfully");
    } catch (error) {
      console.error("Error deleting skill:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "category", title: "Category" },
    { prop: "name", title: "Skill Name" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={`/settings/skills/edit/${row._id}`}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = skills.map((skill) => ({
    category: skill.category.toUpperCase(),
    name: skill.name.toUpperCase(),
    _id: skill._id, // Include for delete/edit actions
  }));

  // Filter the data based on the skill name
  const filteredData = tableData.filter(
    (item) => item.name && item.name.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Skill List</h4>
            <Link
              variant="primary"
              to={"/settings/skills/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Skill</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Skill Name"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default SkillList;
